// @flow

import React from "react";
import { localize } from "redux-i18n";
import { transformSecondsInHours } from "@transformers/date";
import { GSGrid, Pagination, View, Text } from "@components";
import type { RoleSummary as RoleSummaryType } from "@modules/employee/reducer/employment-details/types";
import { Fragment } from "react";

type Props = $Exact<{
  roleSummary: Array<RoleSummaryType>,
  pagination?: $Exact<{
    pageNumber: number,
    totalPages: number,
    pageSize: number,
    totalElements: number,
  }>,
  onChange: () => void,
  ...PropsFromLocalize,
}>;

class ExportRoleSummary extends React.Component<Props> {
  get roleSummaryColumns() {
    return [
      {
        key: "id",
        name: this.props.t("POSITION_ID"),
      },
      {
        key: "employeePositionReference",
        name: this.props.t("POSITION_REF"),
        align: "left",
      },
      {
        key: "jobTitle",
        name: this.props.t("JOB_TITLE"),
        align: "left",
      },
      {
        key: "staffGroup",
        name: this.props.t("STAFF_GROUP"),
        renderCell: ({ row }: Object) => (row.staffGroup || {}).name || "",
        align: "left",
      },
      {
        key: "department",
        name: this.props.t("DEPARTMENT"),
        renderCell: ({ row }: Object) => row.organisationalUnit.name,
        align: "left",
      },
      {
        key: "weeklyContractedHours",
        name: this.props.t("WEEKLY_CONTRACTED_HOURS"),
        renderCell: ({ row }: Object) =>
          transformSecondsInHours(row.weeklyContractedHoursInSeconds),
      },
      {
        key: "daysPerYear",
        name: this.props.t("DAYS_PER_YEAR"),
      },
      {
        key: "fte",
        name: this.props.t("FTE"),
      },
    ];
  }

  get totalPages() {
    return this.props.pagination
      ? Math.ceil(this.props.pagination.totalElements / this.props.pagination.pageSize)
      : 0;
  }

  render() {
    return (
      <View className="gs-container" gap={6}>
        <Text type="h5" text={this.props.t("ROLE_DETAILS")} />

        <GSGrid columns={this.roleSummaryColumns} rows={this.props.roleSummary} />
        {this.props.pagination && (
          <Pagination
            className="mx-auto d-block"
            currentPage={this.props.pagination.pageNumber}
            totalPages={this.totalPages}
            onChange={this.props.onChange}
          />
        )}
      </View>
    );
  }
}

export default localize()(ExportRoleSummary);
